/**
 * Lazy-loads mapbox-gl on demand (42MB module).
 * Import this instead of 'mapbox-gl' directly to avoid loading it globally.
 */

let mapboxPromise = null;

export const loadMapbox = () => {
  if (!mapboxPromise) {
    mapboxPromise = import('mapbox-gl').then((mod) => {
      const mapboxgl = mod.default;
      mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || '';
      // Dynamically inject CSS
      if (!document.querySelector('link[href*="mapbox-gl"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';
        document.head.appendChild(link);
      }
      return mapboxgl;
    });
  }
  return mapboxPromise;
};

export default loadMapbox;
